import Button from "components/LSRevamp/common/Button"
import React, { FunctionComponent, useEffect, useState } from "react"
import useDevice from "hooks/useDevice"
import { getIeltsMockTestUrl } from "utils/url_utils"
import { trackEventAsync } from "scripts/segment"
import { navRoutes } from "page_routes"
import {
  liyABVariant,
  liyButtonData,
} from "components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/constant"
import { TestPrepApi } from "components/Profile/IeltsProfile/TestPrep/redux/TestPrepApi"
import { ieltsPageName } from "utils/events-utils"

import { useDispatch, useSelector } from "react-redux"
import { lsqTriggerGetApiSlice } from "components/Ielts/IeltsEliteDemo/redux/IeltsEliteSlice"
import { State } from "Interfaces/storeSchema"

interface Props {
  variant: number
}

const BottomButton: FunctionComponent<Props> = ({ variant }) => {
  const { isMobile } = useDevice()
  const [isTestAttempted, setIsTestAttempted] = useState<boolean>(false)
  const MOCKTEST_EXAM_ID = 45
  const dispatch = useDispatch()
  const { inboundSalesNumber } = useSelector((state: State) => state.IeltsElite)

  const getMockTestData = async () => {
    try {
      const res = await TestPrepApi.fetchMockTestResultV4("45")
      if (
        res.data.success &&
        res?.data?.data &&
        res?.data?.data?.ieltsScoreCard?.length > 0
      )
        setIsTestAttempted(true)
      else setIsTestAttempted(false)
    } catch (e) {
      setIsTestAttempted(false)
    }
  }

  useEffect(() => {
    getMockTestData()
  }, [])

  const onclick = async () => {
    if (variant == liyABVariant.callNow) {
      dispatch(lsqTriggerGetApiSlice())
      await trackEventAsync("Click", {
        widgetName: "L2E Thank You Page Subsection",
        contentFormat: "Button",
        widgetFormat: "Banner",
        pageName: "L2E Thank You Page with Call Now",
      })

      document.location.href = inboundSalesNumber
        ? `tel:${inboundSalesNumber}`
        : "tel:08065196400"
    } else if (variant == liyABVariant.allCourse) {
      await trackEventAsync("Click", {
        widgetName: "L2E Thank You Page Subsection",
        contentFormat: "Button",
        widgetFormat: "Banner",
        pageName: "L2E Thank You Page with Courses",
      })
      window.open(navRoutes.IELTS_ALL_BATCHES, "_self")
    } else if (variant == liyABVariant.menaUser) {
      await trackEventAsync("Click", {
        contentName: " Attempt Test",
        pageName: ieltsPageName.THANQ_PAGE_MENA,
      })
      window.open(
        getIeltsMockTestUrl(
          isTestAttempted
            ? `mock_test/result/${MOCKTEST_EXAM_ID}`
            : `mock_test/${MOCKTEST_EXAM_ID}`,
        ),
        "_self",
      )
    }
  }

  if (variant)
    return (
      <div className="px-4 pt-8 md:py-8 md:max-w-[800px] mx-auto z-20 relative">
        <div className="fixed md:static bottom-0 left-0 w-full">
          <div
            className={`md:flex md:justify-center md:items-stretch  w-full bg-white rounded-t-[12px] md:rounded-[12px] shadow-[0px_-9px_27px_0px_rgba(0,0,0,0.08)] ${
              variant === liyABVariant.menaUser ? "" : "md:gap-4"
            }`}
          >
            <div
              className={`p-4 md:p-6 text-[#03021B] text-center md:text-left w-full`}
            >
              <div
                className={`pb-4 ${
                  variant === liyABVariant.menaUser
                    ? "text-[14px] md:text-[15px]"
                    : "md:text-[18px] font-bold"
                } `}
              >
                {liyButtonData[variant]?.content || ""}
              </div>
              {liyButtonData[variant]?.subContent && (
                <p className="text-xs text-[#77768E] -mt-4 mb-4">
                  {liyButtonData[variant]?.subContent}
                </p>
              )}
              <Button
                color="text-white font-semibold !rounded-[4px] shadow-[0px_4px_8px_-2px_rgba(16,24,40,0.10),0px_2px_4px_-2px_rgba(16,24,40,0.06)]"
                text={liyButtonData[variant]?.buttonText || ""}
                backgroundColor="bg-[#443EFF] px-8 w-full md:w-auto"
                trackingEvent={onclick}
                icon={
                  variant == liyABVariant.menaUser ||
                  variant == liyABVariant.allCourse ? (
                    <img
                      src="/assets/icons/practice_tab/whitearrow.svg"
                      width={18}
                      height={18}
                    />
                  ) : null
                }
                iconPosition="right"
              />
            </div>
            {!isMobile && (
              <div className="relative w-full h-full">
                {variant === liyABVariant.menaUser ? (
                  <img
                    src={`${process.env.CDN_URL}/assets/icons/band-p.png`}
                    height={140}
                    width={350}
                    alt="liy-scholar-logo"
                    className="z-20 ml-auto   relative"
                  />
                ) : (
                  <img
                    src={`${process.env.CDN_URL}/assets/icons/liy/illustration.png`}
                    height={185}
                    width={180}
                    alt="liy-scholar-logo"
                    className="z-20 ml-auto pt-4 mr-12 relative"
                  />
                )}
                <img
                  src={`${process.env.CDN_URL}/assets/icons/liy/bg_button.svg`}
                  className="absolute top-0 left-0 md:left-[auto] md:right-0 w-full md:w-auto h-full md:h-auto"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    )
  else return null
}
export default BottomButton
